// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../../states';
import { type Selector, type SelectorMaker } from '../../../../types/selectors';
import { BoomLabelsBySkinId } from '../../constants/labels';
import BoomUIBySkinId from '../../constants/ui';
import { type BoomSkinId } from '../../types/global';
import { type BoomStepStatus } from '../../types/steps';

type SelectorProps = {
  skinId: BoomSkinId;
  stepStatus: BoomStepStatus;
  nbWonSteps: number;
};

const getStepStatusFromProps = (_: StateType, { stepStatus }: SelectorProps) => stepStatus;
const getSkinIdFromProps = (_: StateType, { skinId }: SelectorProps) => skinId;
const getNbWonStepsFromProps = (_: StateType, { nbWonSteps }: SelectorProps) => nbWonSteps;

type BoomStepDetailsInfoPropsType = {
  titleLabel: string;
  titleColor: string;
};

const makeBoomStepDetailsInfoPropsSelector: SelectorMaker<BoomStepDetailsInfoPropsType> = () => {
  const selectTitleLabel: Selector<string> = createSelector(
    [getSkinIdFromProps, getNbWonStepsFromProps],
    (skinId, nbWonSteps) => BoomLabelsBySkinId[skinId]?.StepShortTitleByNbWonSteps[nbWonSteps],
  );

  const selectTitleColor: Selector<string> = createSelector(
    [getSkinIdFromProps, getStepStatusFromProps],
    (skinId, stepStatus) => BoomUIBySkinId[skinId]?.TitleColorByStepStatus[stepStatus],
  );

  return createSelector([selectTitleLabel, selectTitleColor], (titleLabel, titleColor) => ({
    titleLabel,
    titleColor,
  }));
};

export default makeBoomStepDetailsInfoPropsSelector;
